import { authService, formatApiError } from "@/services/authService";

/** Project sub-resource API — auth headers via authService.http interceptor. */
export const projectApi = {
    // Project
    updateProject: (pid, body) => authService.http.put(`/projects/${pid}`, body).then((r) => r.data),

    // Mixes
    listMixes: (pid) => authService.http.get(`/projects/${pid}/mixes`).then((r) => r.data),
    createMix: (pid, body) => authService.http.post(`/projects/${pid}/mixes`, body).then((r) => r.data),
    updateMix: (mid, body) => authService.http.put(`/mixes/${mid}`, body).then((r) => r.data),
    deleteMix: (mid) => authService.http.delete(`/mixes/${mid}`).then((r) => r.data),

    // Geometries
    listGeometries: (pid) => authService.http.get(`/projects/${pid}/geometries`).then((r) => r.data),
    createGeometry: (pid, body) => authService.http.post(`/projects/${pid}/geometries`, body).then((r) => r.data),
    updateGeometry: (gid, body) => authService.http.put(`/geometries/${gid}`, body).then((r) => r.data),
    deleteGeometry: (gid) => authService.http.delete(`/geometries/${gid}`).then((r) => r.data),

    // Scenarios
    listScenarios: (pid) => authService.http.get(`/projects/${pid}/thermal_scenarios`).then((r) => r.data),
    createScenario: (pid, body) => authService.http.post(`/projects/${pid}/thermal_scenarios`, body).then((r) => r.data),
    updateScenario: (sid, body) => authService.http.put(`/thermal_scenarios/${sid}`, body).then((r) => r.data),
    deleteScenario: (sid) => authService.http.delete(`/thermal_scenarios/${sid}`).then((r) => r.data),

    // Pours
    listPours: (pid) => authService.http.get(`/projects/${pid}/pours`).then((r) => r.data),
    createPour: (pid, body) => authService.http.post(`/projects/${pid}/pours`, body).then((r) => r.data),
    updatePour: (pour_id, body) => authService.http.put(`/pours/${pour_id}`, body).then((r) => r.data),
    deletePour: (pour_id) => authService.http.delete(`/pours/${pour_id}`).then((r) => r.data),
    reorderPours: (pid, list) => authService.http.post(`/projects/${pid}/pours/reorder`, list).then((r) => r.data),

    // Maturity / strength
    getMaturity: (mid) => authService.http.get(`/mixes/${mid}/maturity_settings`).then((r) => r.data),
    upsertMaturity: (mid, body) => authService.http.put(`/mixes/${mid}/maturity_settings`, body).then((r) => r.data),
    getCalibration: (mid) => authService.http.get(`/mixes/${mid}/strength_calibration`).then((r) => r.data),
    upsertCalibration: (mid, body) => authService.http.put(`/mixes/${mid}/strength_calibration`, body).then((r) => r.data),
    fitCalibration: (mid, points) => authService.http.post(`/mixes/${mid}/strength_calibration/fit`, { points }).then((r) => r.data),

    // Library
    listAggregates: () => authService.http.get(`/library/aggregates`).then((r) => r.data),

    // Solver
    runSolver: (body) => authService.http.post(`/solver/run`, body).then((r) => r.data),
    listJobs: (params = {}) => authService.http.get(`/solver/jobs`, { params }).then((r) => r.data),
    getJob: (jid) => authService.http.get(`/solver/jobs/${jid}`).then((r) => r.data),
    cancelJob: (jid) => authService.http.post(`/solver/jobs/${jid}/cancel`).then((r) => r.data),
    getResult: (rid) => authService.http.get(`/solver/results/${rid}`).then((r) => r.data),

    // ── Phase 2B-iii — Probes, monitoring ingest, monitored strength estimates ──
    listProbes: (pour_id) => authService.http.get(`/pours/${pour_id}/probes`).then((r) => r.data),
    createProbe: (pour_id, body) => authService.http.post(`/pours/${pour_id}/probes`, body).then((r) => r.data),
    updateProbe: (probe_id, body) => authService.http.put(`/probes/${probe_id}`, body).then((r) => r.data),
    deleteProbe: (probe_id) => authService.http.delete(`/probes/${probe_id}`).then((r) => r.data),

    uploadMonitoringCsv: (pour_id, file) => {
        const fd = new FormData();
        fd.append("file", file);
        return authService.http.post(`/pours/${pour_id}/monitoring/csv`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
        }).then((r) => r.data);
    },
    postSensorData: (project_id, body) => authService.http.post(`/v1/projects/${project_id}/sensor_data`, body).then((r) => r.data),
    getMonitoring: (pour_id) => authService.http.get(`/pours/${pour_id}/monitoring`).then((r) => r.data),
    listStrengthEstimates: (pour_id, source) => authService.http.get(`/pours/${pour_id}/strength_estimates`, {
        params: source ? { source } : {},
    }).then((r) => r.data),

    // ── Phase 2B-iv · calibration diagnostic + revisions ──
    runDiagnostic: (pour_id) => authService.http.post(`/pours/${pour_id}/calibrate/diagnose`).then((r) => r.data),
    listRevisions: (mix_id) => authService.http.get(`/mixes/${mix_id}/maturity_settings/revisions`).then((r) => r.data),
    applyDiagnostic: (mix_id, body) => authService.http.post(`/mixes/${mix_id}/maturity_settings/revisions`, body).then((r) => r.data),
    activateRevision: (mix_id, rev_id) => authService.http.post(`/mixes/${mix_id}/maturity_settings/revisions/${rev_id}/activate`).then((r) => r.data),
};

export { formatApiError };
